export enum notificationTypeEnum {
  MISE = 'mise',
  ALERT_LOW = 'alert-low',
  ALERT_MEDIUM = 'alert-medium',
  ALERT_HIGH = 'alert-high',
  MESSAGE = 'message',
  SEPARATOR = 'separator',
}
